import React from 'react'
import { observable, toJS } from 'mobx'
import { useOnOperationExecute } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'
import get from 'lodash/get'
import set from 'lodash/set'

function TransformEntriesToObservableMaps ({ path = null }) {
  function transformCollection (collection) {
    collection.forEach((entry, index) => {
      if (typeof entry.get !== 'function') {
        collection[index] = observable.map(Object.entries(toJS(entry)))
      }
    })
  }

  useOnOperationExecute(({ collection }) => {
    if (path === null) {
      transformCollection(collection)
    } else {
      collection.forEach((entry, index) => {
        if (typeof entry.get !== 'function') {
          const entry = toJS(collection[index])
          const collectionValue = get(entry, path)

          if (collectionValue) {
            transformCollection(collectionValue)
            set(entry, path, collectionValue)
          }

          collection[index] = entry
        }
      })
    }
  })

  return null
}

export default observer(TransformEntriesToObservableMaps)
